import { render, staticRenderFns } from "./MothersDay_cocktailsSection.vue?vue&type=template&id=778cadf0&scoped=true"
import script from "./MothersDay_cocktailsSection.vue?vue&type=script&lang=ts"
export * from "./MothersDay_cocktailsSection.vue?vue&type=script&lang=ts"
import style0 from "./MothersDay_cocktailsSection.vue?vue&type=style&index=0&id=778cadf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778cadf0",
  null
  
)

export default component.exports